export interface HitboxDefinition {
  offsetX: number;
  offsetY: number;
  width: number;
  height: number;
  scale?: number;
  verticalOffset?: number;
}

export const ObstacleHitboxes: Record<string, HitboxDefinition> = {
  obstacle_boxes: {
    offsetX: 0.3,
    offsetY: 0.1,
    width: 0.5,
    height: 0.8,
    scale: 0.5,
    verticalOffset: 0.1,
  },
  obstacle_cucumber: {
    offsetX: 0.15,
    offsetY: 0.75,
    width: 0.6,
    height: 0.3,
    scale: 0.2,
    verticalOffset: 0,
  },
  obstacle_flowerpot: {
    offsetX: 0.1,
    offsetY: 0.3,
    width: 0.7,
    height: 0.6,
    scale: 0.4,
    verticalOffset: 0.05,
  },
  obstacle_laundry: {
    offsetX: 0.1,
    offsetY: 0.1,
    width: 0.8,
    height: 0.8,
    scale: 0.3,
    verticalOffset: 0,
  },
  obstacle_roomba: {
    offsetX: 0.15,
    offsetY: 0.3,
    width: 0.7,
    height: 0.5,
    scale: 0.3,
    verticalOffset: 0.15,
  },
  obstacle_waterpool: {
    offsetX: 0.15,
    offsetY: 0.55,
    width: 0.7,
    height: 0.2,
    scale: 0.3,
    verticalOffset: 0.2,
  },
  obstacle_washingmachine: {
    offsetX: 0.2,
    offsetY: 0.15,
    width: 0.6,
    height: 0.7,
    scale: 0.5,
    verticalOffset: 0.15,
  },
  poop: {
    offsetX: 0.3,
    offsetY: 0.5,
    width: 0.6,
    height: 0.4,
    scale: 0.3,
    verticalOffset: 0,
  },
  platform_short: {
    offsetX: 0,
    offsetY: 0,
    width: 1.0,
    height: 1.0,
    scale: 0.4,
    verticalOffset: 0,
  },
  platform_medium: {
    offsetX: 0,
    offsetY: 0,
    width: 1.0,
    height: 1.0,
    scale: 0.4,
    verticalOffset: 0,
  },
  platform_long: {
    offsetX: 0,
    offsetY: 0,
    width: 1.0,
    height: 1.0,
    scale: 0.4,
    verticalOffset: 0,
  },
  chicken_treat: {
    offsetX: 0.15,
    offsetY: 0.15,
    width: 0.7,
    height: 0.7,
    scale: 0.25,
    verticalOffset: 0,
  },
};

export const PlayerHitboxes: Record<string, HitboxDefinition> = {
  running: {
    offsetX: 0.05,
    offsetY: 0.0,
    width: 0.75,
    height: 0.7,
  },
  jumping: {
    offsetX: 0.1,
    offsetY: 0.35,
    width: 0.65,
    height: 0.4,
  },
};
